'use strict';

var $                   = require('jquery');
var Core                = require('../core/core.js');

/**
 * Creates a Tab
 *
 * @class
 */

class ModalButton extends Core {

    _defaults() {
        return {
            target: '',
            fields: {
                'title': '',
                'style': false
            }
        };
    }

    constructor(options) {
        super(options);

        if(options.fields.style && options.fields.style == "inverted"){
            this.template = `<a class='btn btn--m btn--none_base_borders'><div class='btn__txt'><%= title %></div></a>`;
        } else if(options.fields.style && options.fields.style == "dark"){
            this.template = `<a class='btn btn--m btn--dark_modal'><div class='btn__txt'><%= title %></div></a>`;
        }else{
            this.template = `<a class='btn btn--m btn--accent_none_accent'><div class='btn__txt'><%= title %></div></a>`;
        }

        super.render();

        /**
         * Click event
         *
         * @fires Modal#_clicked
         */
        this.$el.on('click', this._clicked.bind(this));


    }

    /**
     * @event Modal#Cioui:Modal:clicked
     * @property {String}Cioui:Modal:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        this.$el.trigger('Cioui:Modal:ModalButton:clicked', e);
    }

}
module.exports = ModalButton;
